<script setup>
import { computed } from 'vue';
import CheckboxInput from 'vue-elements/input/CheckboxInput.vue';
import FieldLabel from '../field/FieldLabel.vue';
import { useErrorProps, useLabelProps } from '../composables/input';
import FieldError from '../../../abstracts/elements/field/_shared/error/fieldError.vue';

const props = defineProps({
    ...useLabelProps,
    ...useErrorProps,
    modelValue: Array,
    options: Array,
});

const emit = defineEmits(['update:modelValue']);

const value = computed({
    get() {
        return props.modelValue;
    },
    set(newValue) {
        emit('update:modelValue', newValue);
    },
});
</script>

<template>
  <div class="checkbox-list">
    <FieldLabel
      v-if="label"
      :id="id"
      :label="label"
    />
    <CheckboxInput
      v-for="option in options"
      :id="id + '-' + option.value"
      :key="option.value"
      v-model="value"
      :value="option.value"
      :flag="option.flag"
    >
      {{ option.label }}
    </CheckboxInput>
    <FieldError :error="error" />
  </div>
</template>
